/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid values for a sort in a Query.
 */
export enum StudyFileSortFieldsV1 {
    FILE_NAME = 'FILE_NAME',
    MIME_TYPE = 'MIME_TYPE',
    VERSION = 'VERSION',
    CREATED_BY = 'CREATED_BY',
    CREATED_AT = 'CREATED_AT',
    MODIFIED_BY = 'MODIFIED_BY',
    LAST_MODIFIED = 'LAST_MODIFIED',
    TRASH = 'TRASH',
    STUDY_FILE_ID = 'STUDY_FILE_ID',
    STATUS = 'STATUS',
    EVENT_ID = 'EVENT_ID',
}